export const CONFIG = {
  regularPrice: 197,
  currentPrice: 47,
  checkoutUrl: "https://tdcrconsulting.com/debt-collector-kill-switch/checkout",
  fileCount: 34,
  demandCount: 68,
  showCustomerProof: true, // Controlled by boolean as per production rule (default is false on live, true here for visual demonstration)
  
  // SEO & General metadata
  title: "Remove Collections Fast | Debt Collector Kill Switch",
  description: "Remove collections fast with 34 debt-validation, credit-bureau dispute, CFPB complaint, lawsuit and garnishment files. Get the complete Kill Switch for $47.",
  canonicalUrl: "https://debtcollectorkillswitch.com/",
  
  // Custom timer quick-start prompt duration in seconds
  countdownMinutes: 5,
};
